import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@fly/core';
import { FlySvgSprite } from '@fly/svg';
import { Callout } from '@radix-ui/themes';

import styles from '../../FlyChat.module.less';

interface FlyChatErrorProps {
  onRetry: () => void;
}

export const FlyChatError: React.FC<FlyChatErrorProps> = ({ onRetry }) => {
  const { t } = useTranslation();
  const chatErrorMessage = t('app.common.errors.global_error', {
    defaultValue: 'An error occurred',
  });
  const chatErrorResponseMessage = t('app.dashboard.chat.response_error', {
    defaultValue: 'There was an error generating a response',
  });
  const regenerate = t('app.dashboard.chat.content.regenerate', {
    defaultValue: 'Regenerate',
  });

  return (
    <div className={styles.errorContainer} data-testid='chat-error'>
      <Callout.Root size='1' variant='soft' color='red'>
        <Callout.Icon>
          <FlySvgSprite name='info_circled' size={16} />
        </Callout.Icon>
        <Callout.Text>{chatErrorMessage}</Callout.Text>
      </Callout.Root>
      <div className={styles.retryContainer}>
        <Text weight='bold' size='1'>
          {chatErrorResponseMessage}
        </Text>
        <Button size='2' variant='surface' onClick={onRetry} iconStart='reload'>
          {regenerate}
        </Button>
      </div>
    </div>
  );
};
